import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import AlertYellowSVG from './alert_yellow.svg';

const WrapperMarker = styled.div`
  width: 20px;
  height: 18px;
`;

const YellowExclamation = styled.img`
  margin-left: 5px;
  width: 20px;
  height: 18px;
  margin-bottom: 10px;
`;

const CustomTooltip = styled(ReactTooltip)`
  &.place-top.type-custom {
    text-size: 10px;
    font-weight: 500;
  }
`;
const toolTipMessage = "If you don’t send this Digest by the end of this month, it will expire and the Tiles will be moved to Unscheduled.";

export const WarningIcon = () => (
  <WrapperMarker
    data-for="tile_digest_tip"
    data-tip={toolTipMessage}
    data-text-color="#FCFCFC"
    data-background-color="rgba(92, 92, 92, 0.6)"
    data-arrow-color="rgba(92, 92, 92, 0.0)"
    data-offset="{'right': 318, 'bottom': 10}"
  >
    <YellowExclamation src={AlertYellowSVG} />
    <CustomTooltip effect="solid" id="tile_digest_tip" />
  </WrapperMarker>
);
